import AdjustOutlined from "@mui/icons-material/AdjustOutlined";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedOutlined from "@mui/icons-material/RadioButtonUncheckedOutlined";
import RemoveCircleOutline from "@mui/icons-material/RemoveCircleOutline";
import { Chip } from "@mui/material";
import { type SaleDocumentSummary } from "../types";
import { purchaseState, purchaseStatusLabel } from "../utils/format";
import {
  neutralChipSx,
  saleTintChipSx,
  successChipSx,
} from "../utils/saleTokens";

interface Props {
  fileCount: SaleDocumentSummary["fileCount"];
  purchasedCount: SaleDocumentSummary["purchasedCount"];
}

/** 購入状況の Chip。色だけに頼らず、文字とアイコンで状態を伝える。 */
export const SalePurchaseChip: React.FC<Props> = ({
  fileCount,
  purchasedCount,
}) => {
  const state = purchaseState({ fileCount, purchasedCount });
  const label =
    state === "unpurchased"
      ? "未購入"
      : purchaseStatusLabel({ fileCount, purchasedCount });
  const iconProps = { "aria-hidden": true, fontSize: "inherit" } as const;
  const icon = {
    unpurchased: <RadioButtonUncheckedOutlined {...iconProps} />,
    partial: <AdjustOutlined {...iconProps} />,
    purchased: <CheckCircleOutline {...iconProps} />,
    none: <RemoveCircleOutline {...iconProps} />,
  }[state];
  const sx = {
    unpurchased: saleTintChipSx,
    partial: saleTintChipSx,
    purchased: successChipSx,
    none: neutralChipSx,
  }[state];

  return (
    <Chip
      component="span"
      size="small"
      icon={icon}
      label={label}
      sx={(theme) => ({
        ...sx(theme),
        whiteSpace: "nowrap",
        fontVariantNumeric: "tabular-nums",
        "& .MuiChip-icon": { color: "inherit", fontSize: "1rem" },
      })}
    />
  );
};
